/* LicensedTime Corporate & Custom quote form: validation, then Shopify's native contact form (every field as contact[...]),
   confirmation state on success. */
(() => {
  'use strict';
  const root = document.querySelector('[data-lt-corp]');
  const form = document.getElementById('lt-corp-form');
  if (!root || !form) return;
  const done = root.querySelector('[data-lt-corp-done]');
  const alertEl = root.querySelector('[data-lt-corp-alert]');
  const submit = root.querySelector('[data-lt-corp-submit]');
  const f = (name) => form.elements[`contact[${name}]`];

  const say = (m) => {
    alertEl.textContent = m || '';
    alertEl.hidden = !m;
  };
  const err = (key, el, on) => {
    const e = form.querySelector(`[data-err="${key}"]`);
    if (e) e.hidden = !on;
    if (el && el.setAttribute) el.setAttribute('aria-invalid', on ? 'true' : 'false');
  };
  const showDone = () => {
    form.hidden = true;
    done.hidden = false;
    done.focus();
  };

  const fill = () => {
    const company = f('Company').value.trim();
    f('Subject').value = `Quote request: ${company || f('name').value.trim()}`;
    const line = (label, el) => (el && String(el.value).trim() ? `${label}: ${String(el.value).trim()}` : null);
    f('body').value = [
      f('Subject').value,
      '',
      line('Name', f('name')),
      line('Company or organization', f('Company')),
      line('Email', f('email')),
      line('Phone', f('phone')),
      line('Looking for', f('Looking for')),
      line('Quantity', f('Quantity')),
      line('Needed by', f('Needed by')),
      '',
      line('Details', f('Details')),
      '',
      'Logo: ask when replying.'
    ]
      .filter((x) => x !== null)
      .join('\n');
  };

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    say('');
    if (root.querySelector('#lt-corp-website').value) {
      showDone(); // a bot filled the hidden field: pretend it worked, send nothing
      return;
    }
    const bad = [
      ['name', f('name'), !f('name').value.trim()],
      ['email', f('email'), !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f('email').value.trim())]
    ];
    bad.forEach(([k, el, b]) => err(k, el, b));
    const first = bad.find((x) => x[2]);
    if (first) {
      first[1].focus();
      return;
    }
    fill();
    submit.disabled = true;
    submit.textContent = 'Sending…';
    const reset = () => {
      submit.disabled = false;
      submit.textContent = 'Send request';
    };
    fetch(form.action, { method: 'POST', body: new FormData(form), redirect: 'follow' })
      .then((r) => {
        if (/\/challenge/.test(r.url)) {
          form.submit(); // Shopify's spam check needs the normal post
          return;
        }
        if (r.ok && /contact_posted=true/.test(r.url)) {
          showDone();
          return;
        }
        throw new Error('failed');
      })
      .catch(() => say('We could not send that just now. Please try again, or email us.'))
      .finally(reset);
  });

  const q = new URLSearchParams(window.location.search);
  if (q.get('contact_posted') === 'true' || q.get('state') === 'done') showDone();
})();
